export const districts = [
{
    id : "UG-314",
    name: "Abim",
    region: "North",
    size: "2346",
    size_units: "sq. kms",
    counties: [
        {
            name: "Labwor",
            sub_counties: [
                {
                    name : "Abim",
                    parishes : [
                        {
                            name: "Atunga",
                            sub_parishes: [
                                {
                                    name: "Oryotene",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                },
                                {
                                    name: "Apelkere",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                },
                                {
                                    name: "Atugo",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                },
                                {
                                    name: "Otalabar",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kanu",
                            sub_parishes: [
                                {
                                    name: "Kanu Health Centre II",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Arembwola",
                            sub_parishes: [
                                {
                                    name: "Arembwola Pr. Sch",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Aninata",
                            sub_parishes: [
                                {
                                    name: "Aninata Pr. Sch",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Alerek",
                    parishes : [
                        {
                            name: "Koya",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Loyoroit",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Otumpili",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Wilela",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Lotukei",
                    parishes : [
                        {
                            name: "Achangali",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Awach",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Oporoth",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Orwamuge",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Morulem",
                    parishes : [
                        {
                            name: "Adea",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Angolebwal",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Aremo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Katabok",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Nyakwae",
                    parishes : [
                        {
                            name: "Opopongo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Oreta",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pupukamuya",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Rogom",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }  
                    ]
                },
                {
                    name : "Abim Town Council",
                    parishes : [{
                        name: "",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    }]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-301",
    name: "Adjumani",
    region: "North",
    size: "2962",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "East Moyo",
            sub_counties: [
                {
                    name : "Adjumani TC",
                    parishes : [
                        {
                            name: "Biyaya",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Central",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Cesia",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Adropi",
                    parishes : [
                        {
                            name: "Esia",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Jihwa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lajopi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Marindi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Omi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Openzinzi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Ciforo",
                    parishes : [
                        {
                            name: "Gulinya",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kiraba",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Loa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Maaji",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Mugi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Okangali",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Opejo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Dzaipi",
                    parishes : [
                        {
                            name: "Ajugopi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Arinyapi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Elegu",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Liri",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },

                    ]
                },
                {
                    name : "Ofua",
                    parishes : [
                        {
                            name: "Becere",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Itirikwa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Odu",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Subbe",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Tianyu",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Zoka",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Pekelle",
                    parishes : [
                        {
                            name: "Ataboo Central",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Boroli",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Fuda",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lewa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Meliaderi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pereci",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Zoka Fr",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                }  
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-322",
    name: "Agago",
    region: "North",
    size: "3503",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Agago",
            sub_counties: [
                {
                    name : "Adilang",
                    parishes : [
                        {
                            name: "Kulaka",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Labwa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lalal",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lapyem",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ligi Ligi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ngekidi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Orina",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Agago Tc",
                    parishes : [
                        {
                            name: "Agago Central Ward Ajali",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ngora",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pampara",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Arum",
                    parishes : [
                        {
                            name: "Acholi Pii",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Agelec",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alela",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kazikazi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Kalongo TC",
                    parishes : [
                        {
                            name: "Akado",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alupere",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kubuor",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Oret",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Town Ward",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Katomor",
                    parishes : [
                        {
                            name: "Apobo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lukee",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ogong",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Olyelo Widyel",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Omato Wee",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Otek",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Lamiyo",
                    parishes : [
                        {
                            name: "Ojur",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Otaka",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Paicam",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Polcani",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        } 
                    ]
                },
                {
                    name : "Lapono",
                    parishes : [
                        {
                            name: "Amyel",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Hunting Area",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kaket",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lapono Muk",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lira Kato",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ojole",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Lira Palwo",
                    parishes : [
                        {
                            name: "Ademi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Agengo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lanyinyiri",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Latome",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Omungo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Lukole",
                    parishes : [
                        {
                            name: "Kiteny",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ladere",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ngudi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ngwero",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Olung",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Otumpili",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Omiya Pachwa",
                    parishes : [
                        {
                            name: "Laita",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lakwa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lojim",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lomoi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Omwot",
                    parishes : [
                        {
                            name: "Atece",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Awonodwe",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "latinling",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Tenge",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Paimol",
                    parishes : [
                        {
                            name: "Mutto",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ngora",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Omia Pachwa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pacabol",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Paimol Ha",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Taa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Parabongo",
                    parishes : [
                        {
                            name: "Pabala",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pacer",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pakor",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Parumu",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Town Board",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Patongo",
                    parishes : [
                        {
                            name: "Kal",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lakwa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lukwangole",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Odongokiwinyo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }   
                    ]
                },
                {
                    name : "Patongo TC",
                    parishes : [
                        {
                            name: "Akomo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Forest",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Oporot",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pece",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }

                    ]
                },
                {
                    name : "Wol",
                    parishes : [
                        {
                            name: "Atut",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Guda",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kal-agum",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lamit",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Mura",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ogole",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Paluti",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Prabond Fr",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Rogo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-323",
    name: "Alebtong",
    region: "North",
    size: "1535",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Ajuri",
            sub_counties: [
                {
                    name : "Abako",
                    parishes : [
                        {
                            name: "Acede",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alanyi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amononeno",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Awapinyi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ojul",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Olyet",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Owalo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Amugu",
                    parishes : [
                        {
                            name: "Abongoatin",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Abunga",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ajonyi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Omee",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Awei",
                    parishes : [{
                        name: "",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    }]
                },
                {
                    name : "Omoro",
                    parishes : [
                        {
                            name: "Abukamola",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alolololo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Angetta",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ocokober",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Oculokori",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Omarari",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Moroto",
            sub_counties: [
                {
                    name : "Abia",
                    parishes : [{
                        name: "",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    }]
                },
                {
                    name : "Akura",
                    parishes : [{
                        name: "",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    }]
                },
                {
                    name : "Alebtong TC",
                    parishes : [{
                        name: "",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    }]
                },
                {
                    name : "Aloi",
                    parishes : [
                        {
                            name: "Akura",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Akwangkei",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alal",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alebtong",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Anara",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Anyanga",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Awiepek",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Otwek-toke",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Apala",
                    parishes : [
                        {
                            name: "Abangoimany",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Aberidwogo-omera",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Abia",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Abiting",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amonomito",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Atinkok",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Obim",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Okwangole",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Oteno",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Tekulu",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-315",
    name: "Amolatar",
    region: "North",
    size: "1157",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kioga",
            sub_counties: [
                {
                    name : "Aputi",
                    parishes : [
                        {
                            name: "Abalodyanga",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Adonyoimo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Agikdak",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Akwon",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alobokwe",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amai",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Anywali",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Awonagiro",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Otira",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Awelo",
                    parishes : [
                        {
                            name: "Abeja",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Abwong",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Akol",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Akongomit",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Anamido",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Anamwany",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Arwotcek",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Chakwara",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Etam",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Muntu",
                    parishes : [
                        {
                            name: "Abaler",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alemere",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alyecmeda",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amolatar",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Muntu",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Nakatiti",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Nalubwoyo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Namasale",
                    parishes : [
                        {
                            name: "Acii",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Awikori",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Bangaladesh",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Izigwe",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kayago",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kikondo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Nabweyo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Olyaka",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Otuboi Sudds",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Wabinua",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-324",
    name: "Amudat",
    region: "North",
    size: "1626",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Upe",
            sub_counties: [
                {
                    name : "Amudat",
                    parishes : [
                        {
                            name: "Amudat",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Katabok",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Loburin",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Karita",
                    parishes : [
                        {
                            name: "Karita",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Loakales",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Losidok",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Loroo",
                    parishes : [
                        {
                            name: "Abiliep",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Achorichor",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Loroo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-216",
    name: "Amuria",
    region: "East",
    size: "2578",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Amuria",
            sub_counties: [
                {
                    name : "Abarilela",
                    parishes : [
                        {
                            name: "Dodos",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Katine",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ocal",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Olelai",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Amuria TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Apeduru",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Asamuk",
                    parishes : [
                        {
                            name: "Ajaki",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amucu",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Asamuk",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Atirir",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Obur",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Odoon",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Kuju",
                    parishes : [
                        {
                            name: "Abia",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alere",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amilmil",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amusus",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kuju",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Willa",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Wera",
                    parishes : [
                        {
                            name: "Amolo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Angole",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Sugur",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }, 
                        {
                            name: "Wera",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Willa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Orungo",
            sub_counties: [{
                name : "",
                parishes : [
                    {
                        name: "Akeriau",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    },
                    {
                        name: "Moruinera",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    },
                    {
                        name: "Ogongora",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    },
                    {
                        name: "Okunge",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    },
                    {
                        name: "Orungo",
                        sub_parishes: [{
                            name: "",
                            village: [{
                                name: ""
                            }]
                        }]
                    }
                ]
            }]
        }
    ],
    town_status : "false"
},
{
    id: "UG-316",
    name: "Amuru",
    region: "North",
    size: "2578",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kilak",
            sub_counties: [
                {
                    name : "Amuru",
                    parishes : [
                        {
                            name: "Acwa Lolim Gr",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Acwera",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Okungedi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pagak",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pailyec",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pamuca",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Toro",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Atiak",
                    parishes : [
                        {
                            name: "Bibia",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kal",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Okidi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pacilo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Palukere",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Parwacha",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pawel",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pupwonya",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Lamogi",
                    parishes : [
                        {
                            name: "Agwaryugi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Coke",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Giragira",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Guruguru",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Lacor",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Oboo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pagoro",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Palema",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Pabbo",
                    parishes : [
                        {
                            name: "Gaya",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Labala",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pabbo Kal",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Palwong",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Parubanga",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Pogo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-302",
    name: "Apac",
    region: "North",
    size: "2947",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kwania",
            sub_counties: [
                {
                    name : "Abongomola",
                    parishes : [
                        {
                            name: "Abany",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Abwong",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Acungi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Akali",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amorigoga",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Aduku",
                    parishes : [
                        {
                            name: "Aboko",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Adyeda",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alira",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Apire",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ongoceng",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Cawente",
                    parishes : [
                        {
                            name: "Acenlworo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alido",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Atongtidi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Atule",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "inomo",
                    parishes : [
                        {
                            name: "Abedmot",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Agwiciri",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ajok",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Banya",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Inomo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "nambieso",
                    parishes : [
                        {
                            name: "Abuli",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Acaba",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }, 
                        {
                            name: "Anwangi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Aornga",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ayabi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Bung",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Owiny",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Maruzi",
            sub_counties: [
                {
                    name : "Akokoro",
                    parishes : [
                        {
                            name: "Akokoro",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alaro",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amun",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Apoi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Awila",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ayago",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Ayeolyec",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kungu",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Maruzi Hill Fr",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Apac",
                    parishes : [
                        {
                            name: "Abedi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Akere",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Atana",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Atik",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Atopi",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Apac TC",
                    parishes : [
                        {
                            name: "Eastern Ward",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Western Ward",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Cegere",
                    parishes : [
                        {
                            name: "Atigo-lwok",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Barodilo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Cegere",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Kadilani",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Teboke",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
                {
                    name : "Ibuje",
                    parishes : [
                        {
                            name: "Aganga",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Aketo",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Alworoceng",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Amii",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        },
                        {
                            name: "Tarogali",
                            sub_parishes: [{
                                name: "",
                                village: [{
                                    name: ""
                                }]
                            }]
                        }
                    ]
                },
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-303",
    name: "Arua",
    region: "North",
    size: "4343",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Arua Municiapl Council",
            sub_counties: [
                {
                    name : "Arua Hill",
                    parishes : [
                        {
                            name: "Awindiri",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Bazaar",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Mvara",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Oli River",
                    parishes : [
                        {
                            name: "Adalafu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Kenya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Pangisa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }

            ]
        },
        {
            id: "",
            name: "Ayivu",
            sub_counties: [
                {
                    name : "Adumi",
                    parishes : [
                        {
                            name: "Anyara",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Anzu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Kati",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Kubo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Mbaraka",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Mite",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Nyiovura",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Olevu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ombaci",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Aroi",
                    parishes : [
                        {
                            name: "Aliba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Alivu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Bura",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Kamule",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Michu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Robu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ayivuni",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Dadamu",
                    parishes : [
                        {
                            name: "Arivu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ariwara",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Luvu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Odravu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Oduluba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Tanganyika",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Yapi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Manibe",
                    parishes : [
                        {
                            name: "Eleku",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ewadri",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Lufe",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Odravu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ombaci",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ombokoro",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Oreku",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Robu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Oluko",
                    parishes : [
                        {
                            name: "Ambeko",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Anipi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Bunyu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Nyio",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ombokoro",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Onzivu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Turu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Wandi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Yabiavoko",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pajulu",
                    parishes : [
                        {
                            name: "Adalafu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Alivu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Driwala",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Etori",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Komite",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Nyaracu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Pokea",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Urugbo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Yivu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Lower Madi",
            sub_counties: [
                {
                    name : "Ewanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ogoko",
                    parishes : [
                        {
                            name: "Ayavu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Enyio",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Olali",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Pamvara",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Panduku",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Parabok",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pawor",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rhino camp",
                    parishes : [
                        {
                            name: "Anipi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Awuvu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }, 
                        {
                            name: "Bandili",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Eramva",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }, {
                            name: "Gbulukuatuni",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }, 
                        {
                            name: "Manago",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }

                    ]
                },
                {
                    name : "Rigbo",
                    parishes : [
                        {
                            name: "Aliba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ewangu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Kwili",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Luba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ocea",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Odoi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Odubu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Roga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Terego East",
            sub_counties: [
                {
                    name : "Odupi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Omugo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Uriama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Terego West",
            sub_counties: [
                {
                    name : "All-VU/Ajivu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Beleafe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katrini",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Upper Madi",
            sub_counties: [
                {
                    name : "Affaka",
                    parishes : [
                        {
                            name: "Adraa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Elibu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ochebu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ombachi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Omua",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Oribu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Okollo",
                    parishes : [
                        {
                            name: "Ajibu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Baito",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Okollo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Onyomu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Uleppi",
                    parishes : [
                        {
                            name: "Arara",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Katiyi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Laura",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Vura",
            sub_counties: [
                {
                    name : "Ajia",
                    parishes : [
                        {
                            name: "Alivu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Aupi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ayaa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ayayia",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ewa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Nyirivu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ochoko",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Olevu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ombokoro",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Arivu",
                    parishes : [
                        {
                            name: "Awika",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Lazebu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ombavu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Omoo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Pajuru",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ulupi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Logiri",
                    parishes : [
                        {
                            name: "Anyavu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Chiaba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Jiki",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Lazebu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Okavu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Oliba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ozoo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Vura",
                    parishes : [
                        {
                            name: "Ajono",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Anzuu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Anyavu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Eruba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ezuku",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Kuluva",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Nyio",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Opia",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Ringili",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        },
                        {
                            name: "Tilevu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]

                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-217",
    name: "Budaka",
    region: "East",
    size: "408",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Budaka",
            sub_counties: [
                {
                    name : "Budaka",
                    parishes : [
                        {
                            name: "Budaka",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Chali",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Macholi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namengo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Sapiri",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Budaka TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kachomo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kaderuna",
                    parishes : [
                        {
                            name: "Kabuna",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kachomo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Kadenge",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kaderuna",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kiryolo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kodiri",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kotinyanga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakule",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lyama",
                    parishes : [
                        {
                            name: "Lyama",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nasanga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Tademeri",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Naboa",
                    parishes : [
                        {
                            name: "Kakule",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Lupada",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Naboa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namusita",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nasanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "Iki-Iki",
            name: "",
            sub_counties: [
                {
                    name : "Iki-Iki",
                    parishes : [
                        {
                            name: "Iki-Iki",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kadatumi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kaitangole",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kakoli",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Katira",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Petete",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kameruka",
                    parishes : [
                        {
                            name: "Bupuchai",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kameruka",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Lerya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }

                    ]
                },
                {
                    name : "Kamonkoli",
                    parishes : [
                        {
                            name: "Jami",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kadimukoli",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kamonkoli",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Muguti",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Muguti",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nyanza",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Sekulo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katira",
                    parishes : [
                        {
                            name: "Iki-Iki",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mugiti",
                    parishes : [
                        {
                            name: "Iki-Iki",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-218",
    name: "Bududa",
    region: "East",
    size: "316",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Lutseshe",
            sub_counties: [
                {
                    name : "Bubiita",
                    parishes : [
                        {
                            name: "Bukalasi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumakita",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumusi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bundesi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buwaali",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buwagiyu",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Maaba",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt.Elgon Np",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nabulalo",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namasheti",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukalasi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bulucheke",
                    parishes : [
                        {
                            name: "Bumasata",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumwalukani",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bushiyi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busiriwa",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt. Elgon Np",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bumayoka",
                    parishes : [
                        {
                            name: "Bufuma",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumayoka",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bunandutu",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt. Elgon Np",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ulukusi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bushiyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buwali",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nalwaza",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Manjiya",
            sub_counties: [
                {
                    name : "Bududa",
                    parishes : [
                        {
                            name: "Bukibino",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busai",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bushinyekwa",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bududa TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukibokolo",
                    parishes : [
                        {
                            name: "Buirimbi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bukibokolo",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bunamukye",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukigai",
                    parishes : [
                        {
                            name: "Bufukhula",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bulobi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bamukuma",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bamutanda",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Banakhayoti",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Banamubi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bushiribo",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                            {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bumasheti",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bushika",
                    parishes : [
                        {
                            name: "Bufutsa",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumusenyi",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumushisho",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bunabutiti",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bushunya",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt. Elgon Np",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabweya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakatsi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [ 
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-201",
    name: "Bugiri",
    region: "East",
    size: "1038",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukooli Central",
            sub_counties: [
                {
                    name : "Budhaya",
                    parishes : [
                        {
                            name: "Budhaya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bukatu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buwolya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mayuge",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bulesa",
                    parishes : [
                        {
                            name: "Bude",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buwuni",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Igwe",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kitodha",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namasere",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bulidha",
                    parishes : [
                        {
                            name: "Bulidha",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Makoma",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nabigino",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Wakawaka",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buwunga",
                    parishes : [
                        {
                            name: "Bubugo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Bulando",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bupala",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busoga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busowa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buwunga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ggulama",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kamwozi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kanywa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kasaka",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kavule",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kitengesa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Luwoko",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Magoola",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mazinga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nambale",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nawandhuki",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Muterere",
                    parishes : [
                        {
                            name: "Bululu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kayogera",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kitumba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Muterere",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nankoma",
                    parishes : [
                        {
                            name: "Isegero",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Masita",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Matovu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namakoko",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Nankoma",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nsono",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Bukooli North",
            sub_counties: [
                {
                    name : "Bugiri TC",
                    parishes : [
                        {
                            name: "Bwole",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Naluwerere",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ndifakulya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Nkusi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Buluguyi",
                    parishes : [
                        {
                            name: "Bufunda",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bugayi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buluguyi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Muwayo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nsango",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Iwemba",
                    parishes : [
                        {
                            name: "Bugeso",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buyala",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Iwemba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nabirere",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nambo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kapyanga",
                    parishes : [
                        {
                            name: "Bugiri A",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bugunga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Isagaza",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nakavule",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namukonge",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ndifakulya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabukalu",
                    parishes : [
                        {
                            name: "Butyabule",
                            sub_parishes: [
                                {
                                    name: "Butyabule",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Isegero",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kasita",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Lwanika",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nakivumba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nkaiza",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Wangobo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-235",
    name: "Bugweri",
    region: "East",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "",
            sub_counties: [{
                name : "",
                parishes : [{
                    name: "",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                }]
            }]
        }
    ],
    town_status : "false"
},
{
    id: "UG-420",
    name: "Buhweju",
    region: "East",
    size: "748",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Buhweju",
            sub_counties: [
                {
                    name : "Bihanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bitsya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Burere",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Engaju",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Karungu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nsiika TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rwengwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-117",
    name: "Buikwe",
    region: "Central",
    size: "1206",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Buikwe",
            sub_counties: [
                {
                    name : "Buikwe",
                    parishes : [
                        {
                            name: "Buikwe",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kitazi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Lweru",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Malongwe",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ssugu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kawolo",
                    parishes : [
                        {
                            name: "Bibbo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bulyantete",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busabaga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Butinindi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kigenda",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kiteza",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Luwayo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Sagaza",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }

                    ]
                },
                {
                    name : "Lugazi TC",
                    parishes : [
                        {
                            name: "Kabowa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kawotto",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kikaula",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Lugazi Central",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nakazadde",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namengo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyenga",
                    parishes : [
                        {
                            name: "Buzika",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kabizzi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namabu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nyenga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Suunga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Tongolo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
                {
                    name : "Wakisi",
                    parishes : [
                        {
                            name: "Nakalanga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kkonko",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },{
                            name: "Malindi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },{
                            name: "Nakalanga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },{
                            name: "Naminya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },{
                            name: "Wakisi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
                {
                    name : "Njeru TC",
                    parishes : [
                        {
                            name: "Njeru East",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Njeru West",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, {
                            name: "Njeru North",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Njeru South",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "buikwe TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Najja",
                    parishes : [
                        {
                            name: "Busagazi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Gulama",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kisiimba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kiyindi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mawotto",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Namatovu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Tukulu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Najjembe",
                    parishes : [
                        {
                            name: "Buvunya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buwoola",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kabanga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kinoni",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kitigoma",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kizigo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nsakya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngogwe",
                    parishes : [
                        {
                            name: "Ddungi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Kikwayi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Kiringo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Lubongo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Namulesa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Ndolwa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nkokonjeru TC",
                    parishes : [
                        {
                            name: "Bukasa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mulajje",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Nkokonjeru",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "SSI",
                    parishes : [
                        {
                            name: "Kimera",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Kkoba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Lugala",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Lugoba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Muvo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namukuma",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Zzitwe",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-219",
    name: "Bukedea",
    region: "East",
    size: "1032",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukedea",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-118",
    name: "Bukomansimbi",
    region: "Central",
    size: "599",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukomansimbi",
            sub_counties: [
                {
                    name : "Bukedea",
                    parishes : [
                        {
                            name: "Akero",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Akuoro",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Emokori",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kachabule",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kakere",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kaloko",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kamon",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kasoka",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kide",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kocheka",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kokolotum",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kokutu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Okunguro",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Suula",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Too Ward",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kachumbala",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kidongole",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kolir",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Malera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-220",
    name: "Bukwo",
    region: "East",
    size: "524",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kongais",
            sub_counties: [
                {
                    name : "Bukwa",
                    parishes : [
                        {
                            name: "Amanang",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Chepkwasta",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt. Elgon Np",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Muimet",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }

                    ]
                },
                {
                    name : "Chesower",
                    parishes : [
                        {
                            name: "Kamet",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nyalit",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Tulei",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kabei",
                    parishes : [
                        {
                            name: "Kortek",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mokoyon",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mutushet",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Riwo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Suam",
                    parishes : [
                        {
                            name: "Kaptererwa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kwirot",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Senendet",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-225",
    name: "Bulambuli",
    region: "East",
    size: "693",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bulambuli",
            sub_counties: [
                {
                    name : "Buginyanya",
                    parishes : [
                        {
                            name: "bumasifwa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kirwali",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt. Elgon Np",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukhalu",
                    parishes : [
                        {
                            name: "Bukhalu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bunalwere",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Buyaga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bulago",
                    parishes : [
                        {
                            name: "Bumwambu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bunabude",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bunasufwa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busiya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt. Elgon Np",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bulengeni",
                    parishes : [
                        {
                            name: "Bulegeni",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Gamatimbei",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kisekye",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Magala",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mbigi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Namisuni",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Samizi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bunambutye",
                    parishes : [
                        {
                            name: "Buluguya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumufuni",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bwikonge",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buluganya",
                    parishes : [
                        {
                            name: "Buluganya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumasobo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt. Elgon Np",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Masiira",
                    parishes : [
                        {
                            name: "Bufumbo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Gabugoto",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mt. Elgon Np",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Muyembe",
                    parishes : [
                        {
                            name: "Bugwanyi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Nbongo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Sisiyi",
                    parishes : [
                        {
                            name: "Bukibologota",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumugisha",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Gibuzale",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Luzzi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mabono",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Simu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-416",
    name: "Buliisa",
    region: "West",
    size: "1108",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Buliisa",
            sub_counties: [
                {
                    name : "Biiso",
                    parishes : [
                        {
                            name: "Biiso",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Budongo Fr",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Butiaba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kihungya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Budongo",
                    parishes : [
                        {
                            name: "Budongo Fr",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kabango",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kasenene",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kasongoire",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kinyara",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Murchison Falls Np",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nyabyeya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Nyatonzi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buliisa",
                    parishes : [
                        {
                            name: "Kigwera",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kisiabi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ngwedo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-401",
    name: "Bundibugyo",
    region: "West",
    size: "848",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bugyendera",
            sub_counties: [
                {
                    name : "Bukonzo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Harugali",
                    parishes : [
                        {
                            name: "Bukangama",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bupomboli",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kasulenge",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Rwenzori Fr",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Kasitu",
                    parishes : [
                        {
                            name: "Bugando",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },                         
                        {
                            name: "Burondo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kasitu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kikyo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ngamba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ntotoro",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Semuliki Np",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }

                    ]
                },
                {
                    name : "Nduguto",
                    parishes : [
                        {
                            name: "Buyangule",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Butama",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kakuka",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mutunda",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Rwenzori Mountian Fr",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngamba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ntotoro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Sindila",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Bwamba",
            sub_counties: [
                {
                    name : "Bubandi",
                    parishes : [
                        {
                            name: "Bundikahungu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bundikuyali",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bundigoma",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busunga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Lamia",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Njule",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bubukwanga",
                    parishes : [
                        {
                            name: "Bubukwanga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bundikeki",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bundimulangya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bundinyama",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Humya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mataisa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bundibugyo TC",
                    parishes : [
                        {
                            name: "Bimara",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumaddu",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bumate",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Bundibugyo Central",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Hamutiti",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kanyansimbi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Busaru",
                    parishes : [
                        {
                            name: "Bugombwa",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busaru",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Busoru",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Hakitara",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Kaghema",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Karindi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mirambi",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Semuliki Np",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiruwya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kisubba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mirambi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyahuka TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        { 
                                           name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-402",
    name: "Bushenyi",
    region: "West",
    size: "844",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bushenyi Ishaka Municipal Council",
            sub_counties: [
                {
                    name : "Central Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ishaka Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyakabirizi Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Igara",
            sub_counties: [
                {
                    name : "Bumbaire",
                    parishes : [
                        {
                            name: "Bumbaire",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kainamo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kibaare",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kiyaga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Numba",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        }, 
                        {
                            name: "Ruharo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Ryeishe",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                        name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ibaare",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyabugimbi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyeizooba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ruhumuro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bitooma",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakanju",
                    parishes : [
                        {
                            name: "Kabaare",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kakanju",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Katunga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Kitojo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Mazinga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            name: "Rushinya",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        },
                        
                    ]
                },
                {
                    name : "Kyamuhunga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyabubare",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-202",
    name: "Busia",
    region: "East",
    size: "734",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Busia Municipal Council",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Samia-Bugwe",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-221",
    name: "Butaleja",
    region: "East",
    size: "653",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bunyole",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-119",
    name: "Butambala",
    region: "Central",
    size: "403",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Butambala",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-233",
    name: "Butebo",
    region: "East",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "",
            sub_counties: [{
                name : "",
                parishes : [{
                    name: "",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                }]
            }]
        }
    ],
    town_status : "false"
},
{
    id: "UG-120",
    name: "Buvuma",
    region: "Central",
    size: "293",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Buvuma Islands",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-226",
    name: "Buyende",
    region: "East",
    size: "1379",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Budiope East",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Budiope West",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-317",
    name: "Dokolo",
    region: "North",
    size: "1004",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Dokolo",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-121",
    name: "Gomba",
    region: "Central",
    size: "1664",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Gomba",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-304",
    name: "Gulu",
    region: "North",
    size: "3433",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Aswa",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Gulu Municipal Council",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Omoro",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "true"
},
{
    id: "UG-403",
    name: "Hoima",
    region: "West",
    size: "3671",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bugahya",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Buhaguzi",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Hoima Municipal Council",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-417",
    name: "Ibanda",
    region: "West",
    size: "969",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Ibanda County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-203",
    name: "Iganga",
    region: "East",
    size: "1017",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bugweri County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 
        {
            id: "",
            name: "Iganga Municipal Coucil",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kigulu County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-418",
    name: "Isingiro",
    region: "West",
    size: "2613",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukanga County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Isingiro County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-204",
    name: "Jinja",
    region: "East",
    size: "677",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Butembe County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Jinja Municipal Council",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kagoma County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-318",
    name: "Kaabong",
    region: "North",
    size: "7298",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Dodoth East County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Dodoth West County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-404",
    name: "Kabale",
    region: "West",
    size: "1680",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kabale Municipal Council",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Ndorwa County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Rubanda County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Rukiga County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
        
    ],
    town_status : "false"
},
{
    id: "UG-405",
    name: "Kabarole",
    region: "West",
    size: "1810",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bunyangabu County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Burahya Counry",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Fort Portal Municipal Council",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Nakasongola County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-213",
    name: "Kaberamaido",
    region: "East",
    size: "1342",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kaberamaido County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 
        {
            id: "",
            name: "Kalaki County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    // This district is not documented currently
    id: "UG-427",
    name: "Kagadi",
    region: "West",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Buyaga East",
            sub_counties: [
                {
                    name : "Isunga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kabamba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kagadi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kagadi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kamuroza",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kacucuura",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kinyarugonjo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiryanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyanaisoke",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyenzige",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyenzige TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mabaale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mabaale TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyabutanzi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pachwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pachwa TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }

            ]
        },
        {
            id: "",
            name: "Buyaga West",
            sub_counties: [
                {
                    name : "Buhumuliro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Burora",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bwikara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Galiboleka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kanyabeebe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyaterekera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyaterekera TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyakabadiima",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mairirwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpeefu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpeefu Ya Sande Town Coucil",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Muhooro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Muhooro TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Ndaiga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyakarongo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Rugashari",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Rugashari TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Ruteete",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Ruteete TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-428",
    name: "Kakumiro",
    region: "West",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kakumiro county",
            sub_counties: [
                {
                    name : "Birembo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bwaswa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakindo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakumiro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasambya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katikara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kijangi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kikwaya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kisiita",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kisiita TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kitaihuka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpasaana",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nalweyo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nkooko",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-101",
    name: "Kalangala",
    region: "Central",
    size: "451",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bujumba County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kyamuswa County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-222",
    name: "Kaliro",
    region: "East",
    size: "778",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bulamogi County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-122",
    name: "Kalungu",
    region: "Central",
    size: "812",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kalungu",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-102",
    name: "Kampala",
    region: "Central",
    size: "188",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kampala Capital City",
            sub_counties: [
                {
                    name : "Kampala Central",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kawempe Division North",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kawempe Divisioin South",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Makindye Division East",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakawa Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rubaga Division North",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rubaga Division South",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "true"
},
{
    id: "UG-205",
    name: "Kamuli",
    region: "East",
    size: "1514",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bugabula County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 
        {
            id: "",
            name: "Buzaaya County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-413",
    name: "Kamwenge",
    region: "West",
    size: "2340",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kibale County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kitagwenda",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-414",
    name: "Kanungu",
    region: "West",
    size: "1271",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kinkiizi County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-206",
    name: "Kapchorwa",
    region: "East",
    size: "352",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Tingey County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-236",
    name: "Kapelebyong",
    region: "East",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            name : "Kapelebyong",
            parishes : [
                {
                    name: "Airabet",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                },
                {
                    name: "Amaseniko",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                },
                {
                    name: "Kapelebyong",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                },
                {
                    name: "Nyada",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                },
                {
                    name: "Okoboi",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                }
            ]
        },
    ],
    town_status : "false"
},
{
    id: "UG-126",
    name: "Kasanda",
    region: "Central",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukuya",
            sub_counties: [
                {
                    name : "Bukuya SC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukuya TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Litumbi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kijjuna",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mbirizi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Makokoto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kassanda North",
            sub_counties: [
                {
                    name : "Kalwana",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Kassanda SC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kamuli",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kassanda TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiganda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiganda TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kassanda South",
            sub_counties: [
                {
                    name : "Manyogaseka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Myanzi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nalutuntu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-406",
    name: "Kasese",
    region: "West",
    size: "2943",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukonzo County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Busongora County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "Kasese Municipal Council",
            name: "",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-207",
    name: "Katakwi",
    region: "East",
    size: "2306",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "",
            sub_counties: [
                {
                    name : "Toroma County",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "",
                    name: "Usuk County",
                    sub_counties: [
                        {
                            name : "",
                            parishes : [
                                {
                                    name: "",
                                    sub_parishes: [
                                            {
                                            name: "",
                                            village: [
                                                {
                                                    name: ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 
        {
            id: "",
            name: "",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-112",
    name: "Kayunga",
    region: "Central",
    size: "1592",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Baale County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Ntanjeru County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-407",
    name: "Kibaale",
    region: "West",
    size: "4242",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bugangaizi County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Bugangaizi East County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Buyaga County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Buyaga West County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Buyanja County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-103",
    name: "Kiboga",
    region: "Central",
    size: "1592",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kiboga East County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-227",
    name: "Kibuku",
    region: "East",
    size: "481",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kabweri County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "Kibuku County",
            name: "",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                    {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-432",
    name: "Kikuube",
    region: "West",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "",
            sub_counties: [
                {
                    name : "Kiziramfumbi",
                    parishes : [
                        {
                            name: "Kidoma",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiziramfumbi",
                    parishes : [
                        {
                            name: "Munteme",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bugambe",
                    parishes : [
                        {
                            name: "Katanga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyangwali",
                    parishes : [
                        {
                            name: "Kasonga",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-419",
    name: "Kiruhura",
    region: "West",
    size: "4555",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kashongi County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kazo County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Nyabushozi County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-421",
    name: "Kiryandongo",
    region: "West",
    size: "3595",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kibanda North County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 
        {
            id: "",
            name: "Kibanda South County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-408",
    name: "Kisoro",
    region: "West",
    size: "699",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bufumbira County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-305",
    name: "Kitgum",
    region: "North",
    size: "3998",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Chua County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-319",
    name: "Koboko",
    region: "North",
    size: "760",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Koboko County",
            sub_counties: [{
                name : "",
                parishes : [{
                    name: "",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                }]
            }]
        }
    ],
    town_status : "false"
},
{
    id: "UG-325",
    name: "Kole",
    region: "North",
    size: "1071",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kole County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-306",
    name: "Kotido",
    region: "North",
    size: "3620",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Jie County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-208",
    name: "Kumi",
    region: "East",
    size: "1003",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kumi County",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-333",
    name: "Kwania",
    region: "North",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kwanin",
            sub_counties: [
                {
                    name : "Atongtidi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ayabi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ayabi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Chawente",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nambieso",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kwania North",
            sub_counties: [
                {
                    name : "Abongomola",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Aduku",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Aduku TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Akali",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Inomo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Inomo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-228",
    name: "Kween",
    region: "East",
    size: "850",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kween",
            sub_counties: [
                {
                    name : "Benet",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Binyiny",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Binyiny TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Greek River",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kaproron",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kaptoyoy",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kaptum",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kitawoi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kwanyiy",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kworsir",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Moyok",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngenge",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-123",
    name: "Kyankwanzi",
    region: "Central",
    size: "2466",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Butemba",
            sub_counties: [
                {
                    name : "bananywa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "butemba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Butemba TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyankwanzi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nsambya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Ntwentwe",
            sub_counties: [
                {
                    name : "Gayaza",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Kitabona",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mulagi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nkandwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ntwetwe TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Wattuba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }  
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-422",
    name: "Kyegegwa",
    region: "West",
    size: "1747",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kyaka County",
            sub_counties: [
                {
                    name : "Hapuuyo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakabara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasule",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kigambo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyegegwa TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyegwgwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Ruyonza",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rwentuha",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-415",
    name: "Kyenjojo",
    region: "West",
    size: "2357",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Mwenge County",
            sub_counties: [
                {
                    name : "Bufunjo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bugaaki",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Butiiti",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Butunduzi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Butunduzi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katooke",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katooke TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kigaraale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kihuura",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyarusozi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyarusozi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyenjojo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "nyabuharwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyankwanzi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyantungo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-125",
    name: "Kyotera",
    region: "Central",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kyotera County",
            sub_counties: [
                {
                    name : "Kyebe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasasa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kibanda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kifamba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasaali",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kakuuto County",
            sub_counties: [
                {
                    name : "Kakuuto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasensero TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mutukula TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },  
                {
                    name : "Lwankoni",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Kabira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Kirumba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-326",
    name: "Lamwo",
    region: "North",
    size: "5598",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Lamwo County",
            sub_counties: [
                {
                    name : "Agoro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lokung",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Madi Opei",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Padibe East",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Padibe West",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Palabek Gem",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Palabek Kal",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Palabak Ogili",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Paloga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-307",
    name: "Lira",
    region: "North",
    size: "1327",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Erute County",
            sub_counties: [
                {
                    name : "Aweng",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Aromo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ogur",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Odekokwok",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Agali",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Amach",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Barr",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngetta",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "Lira Municipal Council",
            name: "",
            sub_counties: [
                {
                    name : "Adyel",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lira Central",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ojwina",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Railways",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }

    ],
    town_status : "false"
},
{
    id: "UG-229",
    name: "Luuka",
    region: "East",
    size: "648",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Luuka",
            sub_counties: [
                {
                    name : "Bukanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukooma",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bulongo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ikumbya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Irongo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nawampiti",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Waibuga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
                
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-104",
    name: "Luwero",
    region: "Central",
    size: "2216",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bamunanika County",
            sub_counties: [
                {
                    name : "Bamunanika",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "kalagala",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kamira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kikyusa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Zirobwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Katikamu County North",
            sub_counties: [
                {
                    name : "Butuntumula",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katikamu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Luweero TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Luwero",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },

            ]
        },
        {
            id: "",
            name: "Katikamu County South",
            sub_counties: [
                {
                    name : "Bombo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katikamu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mukulubita",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyimbwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wobulenzi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }  
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-124",
    name: "Lwengo",
    region: "Central",
    size: "1024",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukoto County",
            sub_counties: [
                {
                    name : "Lwengo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lwengo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ndagwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },                 
                {
                    name : "Kyazanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyazanga TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Malongo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kingo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kisekka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-114",
    name: "Lyantonde",
    region: "Central",
    size: "883",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kabula County",
            sub_counties: [
                {
                    name : "Kaliiro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasagama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kinuuka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lyakajura",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lyantonde",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lyantonde TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpumudde",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-223",
    name: "Manafwa",
    region: "East",
    size: "533",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bubulo",
            sub_counties: [
                {
                    name : "Bubutu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukhabusi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukhaweka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukiabi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukoho",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bumbo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bumwoni",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bupoto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buwabwala",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lwakhakha TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Magale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mukoto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namabya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Namboko",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Tsekululu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bugobero",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukhofu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukusu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bunabwana",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Busukuya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Butiru",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Butta",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buwagogo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Kaato",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Khabutoola",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Manafwa TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Nalondo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Sibanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Sisuni",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Weswa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }

            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-320",
    name: "Maracha",
    region: "North",
    size: "1572",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Maracha County",
            sub_counties: [
                {
                    name : "Kijomoro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Olufe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Oluvu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Maracha East County",
            sub_counties: [
                {
                    name : "Maracha TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyadri",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Oleba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Tara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Yivu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-105",
    name: "Masaka",
    region: "Central",
    size: "1158",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukoto County Central",
            sub_counties: [
                {
                    name : "Kabonera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Kyanamukaka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Kyesiiga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                }
            ]
        },
        {
            id: "Bukoto County East",
            name: "",
            sub_counties: [
                {
                    name : "Bukakata",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Buwunga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Mukungwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                }
            ]
        },
        {
            id: "Masaka Municipal Council",
            name: "",
            sub_counties: [
                {
                    name : "Katwe/Butego",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Kimaanya/Kyabakuza",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Nyendo/Senyange",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-409",
    name: "Masindi",
    region: "West",
    size: "3932",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Buyenje County",
            sub_counties: [
                {
                    name : "Budongo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Bwijanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Buruli County",
            sub_counties: [
                {
                    name : "Kimengo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Miirya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Pakanyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Masindi Municipality",
            sub_counties: [
                {
                    name : "Central Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Karujubu Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Kigulya Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                },
                {
                    name : "Nyangahya Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]

                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-214",
    name: "Mayuge",
    region: "East",
    size: "1073",
    size_units: "sq. kms",
    counties: [
        {
            id: "Bunya County East",
            name: "",
            sub_counties: [
                {
                    name : "Bukabooli",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buwaaya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kigandalo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpungwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Bunya County South",
            sub_counties: [
                {
                    name : "Busakira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Jaguzi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kityerera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Malongo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Bunya County West",
            sub_counties: [
                {
                    name : "Bukatube",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Imanyiro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mayuge TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wairasa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-209",
    name: "Mbale",
    region: "East",
    size: "517",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bungokho County North",
            sub_counties: [
                {
                    name : "Bubyangu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Budwale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bufumbo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukonde",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lwasso",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakaloke",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakaloke TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namanyonyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wanale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Bunghoko County South",
            sub_counties: [
                {
                    name : "Bukasakya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukhiende",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bumasikye",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bumbobi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bungokho",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Busano",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Busiu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Busoba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lukhonge",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nambale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyondo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }   
            ]
        },
        {
            id: "",
            name: "Mbale Municipality",
            sub_counties: [
                {
                    name : "Industrial Borough",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Northern Borough",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wanale Borough",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-410",
    name: "Mbarara",
    region: "West",
    size: "1781",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Kashari North County",
            sub_counties: [
                {
                    name : "Kagongi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kashare",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rubindi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kashari South County",
            sub_counties: [
                {
                    name : "Bubaare",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukiiro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rubaya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rwanyamahembe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Mbarara Municipality",
            sub_counties: [
                {
                    name : "Biharwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakiika",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakoba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kamukuzi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyakayojo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyamitanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Rwampara",
            sub_counties: [
                {
                    name : "Mwizi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ndeija",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rugando",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-423",
    name: "Mitooma",
    region: "West",
    size: "542",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Ruhinda County",
            sub_counties: [
                {
                    name : "Kabira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kashenshero",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kashenshero TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katenga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mayanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mitooma",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mitooma TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mutura",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rurehe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Ruhinda North County",
            sub_counties: [
                {
                    name : "Butereko",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kanyabwanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiyanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [{
                                        name: ""
                                    }]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-115",
    name: "Mityana",
    region: "Central",
    size: "1542",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Busujju County",
            sub_counties: [
                {
                    name : "Butayunja",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakindu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Maanyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Malangala",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Mityana County North",
            sub_counties: [
                {
                    name : "Bulera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kalangaalo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kikandwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Mityana County South",
            sub_counties: [
                {
                    name : "Namungo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ssekanyonyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Mityana Municipality",
            sub_counties: [
                {
                    name : "Bisimbi Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Central Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ttamu Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-308",
    name: "Moroto",
    region: "North",
    size: "3564",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Matheniko County",
            sub_counties: [
                {
                    name : "Nadunget",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rupa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Moroto Municipality",
            sub_counties: [
                {
                    name : "North Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "South Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Tepeth County",
            sub_counties: [
                {
                    name : "Katikekile",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Tapac",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-309",
    name: "Moyo",
    region: "North",
    size: "1902",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Obongi County",
            sub_counties: [
                {
                    name : "Aliba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Gimara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Itula",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "West Moyo County",
            sub_counties: [
                {
                    name : "Dufile",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Laropi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lefori",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Metu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Moyo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Moyo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-106",
    name: "Mpigi",
    region: "Central",
    size: "1202",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Mwokota County North",
            sub_counties: [
                {
                    name : "Kammengo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Kiringente",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpigi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Muduma",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 
        {
            id: "",
            name: "Mawokota County South",
            sub_counties: [
                {
                    name : "Buwama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kituntu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nkozi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-107",
    name: "Mubende",
    region: "Central",
    size: "4591",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukuya County",
            sub_counties: [
                {
                    name : "Bukuya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kitumbi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Makokoto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Buwekula County",
            sub_counties: [
                {
                    name : "Butoloogo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kitenga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiyuni",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Madudu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kasambya County",
            sub_counties: [
                {
                    name : "Bagezza",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasambya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kibalinga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kigando",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabingoola",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kassanda County North",
            sub_counties: [
                {
                    name : "Kalwana",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kassanda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 
        {
            id: "",
            name: "Kassanda County South",
            sub_counties: [
                {
                    name : "Kiganda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Manyogaseka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Myanzi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nalutuntu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Mubende Municipality",
            sub_counties: [
                {
                    name : "East Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "South Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "West Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-108",
    name: "Mukono",
    region: "Central",
    size: "1829",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Mukono County North",
            sub_counties: [
                {
                    name : "Kyampisi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "Mukono County South",
            name: "",
            sub_counties: [
                {
                    name : "Koome Islands",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpatta",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mpunge",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakisunga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ntenjeru",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "Mukono Municipality",
            name: "",
            sub_counties: [
                {
                    name : "Goma Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mukono Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Nakifuma County",
            sub_counties: [
                {
                    name : "Kasawo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kimenyedde",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabbale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nagojje",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namuganga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ntunda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
        
    ],
    town_status : "false"
},
{
    id: "UG-334",
    name: "Nabilatuk",
    region: "North",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Nabilatuk",
            sub_counties: [
                {
                    name : "Lolachat",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lorengedwat",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabilatuk",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabilatuk TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-311",
    name: "Nakapiripirit",
    region: "North",
    size: "4233",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Chekwi County",
            sub_counties: [
                {
                    name : "Kakomongole",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Loregae",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Moruita",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakapiripirit TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namalu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Pian County",
            sub_counties: [
                {
                    name : "Lolachat",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lorengedwat",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-116",
    name: "Nakaseke",
    region: "Central",
    size: "3461",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Nakaseke North",
            sub_counties: [
                {
                    name : "Kakumilo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kinoni",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kinyogoga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kitto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiwoko TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakaseke Butalangu TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngoma",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngoma TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wakyato",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Nakaseke South",
            sub_counties: [
                {
                    name : "Kaasangombe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kapeeka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "nakaseke",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakaseke TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Semuto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Semuto TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-109",
    name: "Nakasongola",
    region: "Central",
    size: "3303",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bundyebo County",
            sub_counties: [
                {
                    name : "Lwampanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Migyera TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabiswera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Nakitoma",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rwabyata",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Nakasongola County",
            sub_counties: [
                {
                    name : "Kakooge",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakooge TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kalongo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kalungi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nakasongola TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wabinyonyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-230",
    name: "Namayingo",
    region: "East",
    size: "585",
    size_units: "sq. kms",
    counties: [
        {
            id: "Bukooli Island County",
            name: "",
            sub_counties: [
                {
                    name : "Bukana",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lolwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Sigulu Islands",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Bukooli South County",
            sub_counties: [
                {
                    name : "Bukana",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lolwe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Sigula Islands",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Banda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buhemba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buswale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buyinja",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mutumba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namayingo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-234",
    name: "Namisindwa",
    region: "East",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Namisindwa County",
            sub_counties: [
                {
                    name : "Namisindwa TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Magale TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Magale TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
                
            ]
        }, 
        {
            id: "",
            name: "Bubulo East",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-224",
    name: "Namutumba",
    region: "East",
    size: "810",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bukono County",
            sub_counties: [
                {
                    name : "Ivukula",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kibaale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Busiki County",
            sub_counties: [
                {
                    name : "Bulange",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Magada",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namutamba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namutamba TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Nsinze",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-327",
    name: "Napak",
    region: "North",
    size: "4901",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bokora County",
            sub_counties: [
                {
                    name : "Iriiri",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lokopo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lopei",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lorengecora",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lotome",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Matany",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Napak TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngoleriet",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-310",
    name: "Nebbi",
    region: "North",
    size: "1915",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Jonam County",
            sub_counties: [
                {
                    name : "Alwi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pakwach",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pakwach TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Panyango",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Panyimur",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wadelai",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Padyere County",
            sub_counties: [
                {
                    name : "Akworo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Atego",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Erussi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kucwiny",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ndhew",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nebbi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nebbi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyaravur",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Parombo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-231",
    name: "Ngora",
    region: "East",
    size: "637",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Ngora County",
            sub_counties: [
                {
                    name : "Kapir",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kobwin",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mukura",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngora",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngora TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-424",
    name: "Ntoroko",
    region: "West",
    size: "1239",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Ntoroko County",
            sub_counties: [
                {
                    name : "Butungama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bweramule",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kanara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kanara TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Karugutu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Karugutu TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kituuku TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nombe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rwebisengo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rebisengo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-411",
    name: "Ntungamo",
    region: "West",
    size: "2048",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Njara",
            sub_counties: [
                {
                    name : "Bwongyera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ihunga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kibatsi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyaihoko",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rwasharamire TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Ntungamo Municipality",
            sub_counties: [
                {
                    name : "Central Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Eastern Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Western Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Ruhaama County",
            sub_counties: [
                {
                    name : "Itojo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kitwe TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ntungamo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nkakyera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ruhaama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rukoni East",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rukoni West",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rweikiniro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Rushenyi County",
            sub_counties: [
                {
                    name : "Kayonza",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngoma",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rubaare",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rubaare TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rugarama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-328",
    name: "Nwoya",
    region: "North",
    size: "4601",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Nwoya County",
            sub_counties: [
                {
                    name : "Alero",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Anaka (Payira)",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Got Apwoyo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Koch-Goma",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lii",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lungulu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nwoya TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Purongo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-331",
    name: "Omoro",
    region: "North",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "",
            sub_counties: [{
                name : "",
                parishes : [{
                    name: "",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                }]
            }]
        }
    ],
    town_status : "false"
},
{
    id: "UG-329",
    name: "Otuke",
    region: "North",
    size: "1555",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Otuke County",
            sub_counties: [
                {
                    name : "Adwari",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "Ogor",
                    name: "",
                    sub_counties: [
                        {
                            name : "",
                            parishes : [
                                {
                                    name: "",
                                    sub_parishes: [
                                        {
                                            name: "",
                                            village: [
                                                {
                                                    name: ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "Okwang",
                    name: "",
                    sub_counties: [
                        {
                            name : "",
                            parishes : [
                                {
                                    name: "",
                                    sub_parishes: [
                                        {
                                            name: "",
                                            village: [
                                                {
                                                    name: ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "",
                    name: "Olilim",
                    sub_counties: [
                        {
                            name : "",
                            parishes : [
                                {
                                    name: "",
                                    sub_parishes: [
                                        {
                                            name: "",
                                            village: [
                                                {
                                                    name: ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "",
                    name: "Orum",
                    sub_counties: [
                        {
                            name : "",
                            parishes : [
                                {
                                    name: "",
                                    sub_parishes: [
                                        {
                                            name: "",
                                            village: [
                                                {
                                                    name: ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "",
                    name: "Otuke TC",
                    sub_counties: [
                        {
                            name : "",
                            parishes : [
                                {
                                    name: "",
                                    sub_parishes: [
                                        {
                                            name: "",
                                            village: [
                                                {
                                                    name: ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-321",
    name: "Oyam",
    region: "North",
    size: "2190",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Oyam County North",
            sub_counties: [
                {
                    name : "Abok",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Achaba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Aleka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Icheme",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ngai",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Otwal",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Oyam TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Oyam County South",
            sub_counties: [
                {
                    name : "Aber",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kamdini",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Loro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Minakulu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Myene",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-312",
    name: "Pader",
    region: "North",
    size: "3294",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Aruu County",
            sub_counties: [
                {
                    name : "Ogom",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pader",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pader TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Parunga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, 
        {
            id: "",
            name: "Aruu County North",
            sub_counties: [
                {
                    name : "Acholi-bur",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Angagura",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Atanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Laguti",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lapul",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "latanya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pajule",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-332",
    name: "Pakwach",
    region: "North",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-210",
    name: "Pallisa",
    region: "East",
    size: "1030",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Agule county",
            sub_counties: [
                {
                    name : "Agule",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Akisim",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Apopong",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Chelekura",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Gogonyo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kameke",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Butebo County",
            sub_counties: [
                {
                    name : "Butebo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kabwangasi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakoro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kanginima",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Petete",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kibale County",
            sub_counties: [
                {
                    name : "Kibale",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Opwatete",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Pallisa County",
            sub_counties: [
                {
                    name : "Kamuge",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasodo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Olok",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pallisa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pallisa TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Puti-puti",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-110",
    name: "Rakai",
    region: "Central",
    size: "3245",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Buyamba County",
            sub_counties: [
                {
                    name : "Ddwaniro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kacheera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kagamba (buyumba)",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lwamaggwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kakuuto county",
            sub_counties: [
                {
                    name : "Kakuuto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasasa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kibanda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kifamba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyebe",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kooki County",
            sub_counties: [
                {
                    name : "Byakabanda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiziba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyalulangira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lwanda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rakai TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kyotera County",
            sub_counties: [
                {
                    name : "Kabira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kalisizo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kalisizo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasaali",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kirumba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyotera TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Lwankoni",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Nabigasa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-429",
    name: "Rubanda",
    region: "West",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "",
            sub_counties: [{
                name : "",
                parishes : [{
                    name: "",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                }]
            }]
        }
    ],
    town_status : "false"
},
{
    id: "UG-425",
    name: "Rubirizi",
    region: "West",
    size: "1092",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Bunyaruguru County",
            sub_counties: [
                {
                    name : "Katunguru",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kichwamba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Magambo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rubirizi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rutoto",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ryeru",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Katerera County",
            sub_counties: [
                {
                    name : "Katanda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katerera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katerera TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kiguru",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyabakara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
        
    ],
    town_status : "false"
},
{
    id: "UG-431",
    name: "Rukiga",
    region: "West",
    size: "",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "",
            sub_counties: [{
                name : "",
                parishes : [{
                    name: "",
                    sub_parishes: [{
                        name: "",
                        village: [{
                            name: ""
                        }]
                    }]
                }]
            }]
        }
    ],
    town_status : "false"
},
{
    id: "UG-412",
    name: "Rukungiri",
    region: "West",
    size: "1435",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Rubaho County",
            sub_counties: [
                {
                    name : "Buyanja",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kebisoni",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyakishenyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyarushanje",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                
            ]
        },
        {
            id: "",
            name: "Katerere County",
            sub_counties: [
                {
                    name : "Bugangari",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buhunga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bwambara",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyakagyeme",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ruhinda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Rukungiri Municipality",
            sub_counties: [
                {
                    name : "Eastern Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Southern Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Western Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },        
    ],
    town_status : "false"
},
{
    id: "UG-111",
    name: "Ssembabule",
    region: "Central",
    size: "2315",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Lwemiyaga County",
            sub_counties: [
                {
                    name : "Lwemiyaga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ntuusi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }

            ]
        },
        {
            id: "",
            name: "Muwogola County",
            sub_counties: [
                {
                    name : "Lwebitakuli",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mateete",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Muwogola North County",
            sub_counties: [
                {
                    name : "Lugusulu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mijwala",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ssembabule TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    
    ],
    town_status : "false"
},
{
    id: "UG-232",
    name: "Serere",
    region: "East",
    size: "1495",
    size_units: "sq. kms",
    counties: [
        {
            id: "Kasilo County",
            name: "",
            sub_counties: [
                {
                    name : "Bugondo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kadungulu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasilo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Labor",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Pingere",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }

            ]
        },
        {
            id: "",
            name: "Serere County",
            sub_counties: [
                {
                    name : "Atiira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kateta",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyere",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Serere TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Serere/Olio",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-426",
    name: "Sheema",
    region: "West",
    size: "696",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Sheema County North",
            sub_counties: [
                {
                    name : "Kabwohe/ Itendero TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kagango",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kigarama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kyagyenyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Masheruka",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Sheema TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Sheema County South",
            sub_counties: [
                {
                    name : "Bugongi TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kassana",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kashozi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kitagata",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rugarama",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Shuuku",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-215",
    name: "Sironko",
    region: "East",
    size: "401",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Budadiri County West",
            sub_counties: [
                {
                    name : "Bukhulo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukiyi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bunyafwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buteza",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buwalasi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }, 
                {
                    name : "Buwasa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buyobo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nalusala",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Sironko TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Budadiri County East",
            sub_counties: [
                {
                    name : "Budadiri TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bugitimwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Buhugu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukiise",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukyabo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bukyambi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bumalimba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Bumasifwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Butandiga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Masaba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Zesui",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-211",
    name: "Soroti",
    region: "East",
    size: "1366",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Dakabela County",
            sub_counties: [
                {
                    name : "Arapai",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katine",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Tubur",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Soroti County",
            sub_counties: [
                {
                    name : "Asuret",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Gweri",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kamuda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Soroti",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Soroti Municipality",
            sub_counties: [
                {
                    name : "Eastern",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Northern",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Western",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-212",
    name: "Tororo",
    region: "East",
    size: "1192",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Tororo Municipality",
            sub_counties: [
                {
                    name : "Tororo Eastern",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Tororo Western",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "Tororo North County",
            name: "",
            sub_counties: [
                {
                    name : "Merikit",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Molo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mukujju",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Tororo South County",
            sub_counties: [
                {
                    name : "Kwapa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Malaba TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mella",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Osukuru",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "West Budama County North",
            sub_counties: [
                {
                    name : "kirewa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kisoko",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nagongera",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nagongera TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Paya",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Petta",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Sopsop",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "West Budama County South",
            sub_counties: [
                {
                    name : "Iyolwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Magola",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Mulanda",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabuyoga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Rubongi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-113",
    name: "Wakiso",
    region: "Central",
    size: "1882",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Busiro County East",
            sub_counties: [
                {
                    name : "Mende",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nsangi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wakiso",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Wakiso TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Busiro County North",
            sub_counties: [
                {
                    name : "Kakira",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kakira TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kaziba (Masuliita)",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Masuliita TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namayumba",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namayumba TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Busiro County South",
            sub_counties: [
                {
                    name : "Bussi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kasanje",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Katabi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ssisa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Entebbe Minicipality",
            sub_counties: [
                {
                    name : "Divisioiin A",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Division B",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kira Municipality",
            sub_counties: [
                {
                    name : "Bweyogerere Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kira Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Namugongo Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Kyadondo County East",
            sub_counties: [
                {
                    name : "",
                    parishes : [
                        {
                            name: "Nangabo",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Makindye Ssabagabo Municipality",
            sub_counties: [
                {
                    name : "Bunamyaya Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Masajja Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ndejje Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Nansana Municipality",
            sub_counties: [
                {
                    name : "Busukuma Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Gombe Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nabweru Division",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nansana Divisioin",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-313",
    name: "Yumbe",
    region: "North",
    size: "2318",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Aringa County",
            sub_counties: [
                {
                    name : "Apo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kochi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kalulu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kuru",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Ramogi",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Yumbe TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "Aringa North County",
            name: "",
            sub_counties: [
                {
                    name : "Kei",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kerwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Midingo",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Aringa South County",
            sub_counties: [
                {
                    name : "Ariwa",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Drajini/Arajim",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Lodonga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Odravu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
},
{
    id: "UG-330",
    name: "Zombo",
    region: "North",
    size: "940",
    size_units: "sq. kms",
    counties: [
        {
            id: "",
            name: "Okoro County",
            sub_counties: [
                {
                    name : "Abanga",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Jangokoro",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Nyapea",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Paidha",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Paiha TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Zombo TC",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "",
            name: "Ora County",
            sub_counties: [
                {
                    name : "Atyak",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Kango",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Warr",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    name : "Zeu",
                    parishes : [
                        {
                            name: "",
                            sub_parishes: [
                                {
                                    name: "",
                                    village: [
                                        {
                                            name: ""
                                        }   
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    town_status : "false"
}]
